import { useEffect, useState, useRef } from 'react'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from '@mui/material/Button'
import InputGroup from 'react-bootstrap/InputGroup'

const ops = [
    {'name':'is', 'value':'is'},
    {'name':'is not', 'value':'is not'}
]

export function VariableForm( props ) 
{
    const data = props.data 
    const setData = props.setData 

    const [ variable, setVariable ] = useState(null)
    const [ value, setValue ] = useState(null)
    const [ op, setOp ] = useState(null)

    const reload = () => {
        setVariable((data.variable) ? data.variable : "")
        setValue((data.value) ? data.value : "")
        setOp((data.op) ? data.op : "is")
    }

    useEffect( () => { 
        reload() 
    },[data])

    useEffect( () => {
        if( variable == null || value == null || op == null )
        {
            return
        }


        let d = structuredClone(data)

        d.variable = variable 
        d.value = value 
        d.op = op 

        if( JSON.stringify(d) != JSON.stringify(data) )
        {
            setData(d)
        }
    },[ variable, value, op ])

    if( variable == null || value == null || op == null )
    {
        return (
            <></>
        )
    }

    return (
        <div style={{ width:'100%', display:'flex', justifyContent:'space-between' }}>
            <Form.Control style={{ width:'calc(43% - 5px)'}} 
                          placeHolder="Variable" 
                          size="sm"
                          value={variable}
                          onChange={e => setVariable(e.target.value)}
            />
            <Form.Select style={{ width:'50px',
                                  padding: 0,              // No internal spacing
                                  textAlignLast: 'center',     // Center the symbol
                                  appearance: 'none',      // REMOVES the dropdown arrow
                                  backgroundImage: 'none',  // Removes Bootstrap's SVG arrow
                                  border:'1px solid',
                                  background:'#E8E8E8'
                         }} 
                         size="sm"
                         value={op}
                         onChange={ e => setOp(e.target.value)}
            >
                { ops.map( (o,idx) => 
                <option value={o.value} key={idx}>{o.name}</option>
                )}
            </Form.Select>
            <Form.Control style={{ width:'calc(43% - 5px)' }} 
                          placeHolder="Value" 
                          size="sm"
                          value={value}
                          onChange={e => setValue(e.target.value)}
            />
        </div>
    )
}

export function Item( props )
{
    const name = props.name 

    return (
        <div style={{ width:'100%', height:'30px', marginBottom:'5px'}}>
            <div className="d-flex justify-content-start align-items-center" 
                 style={{ width:'100px', height:'100%', float:'left' }}>
                <b>{name}</b>
            </div>
            <div style={{ width:'calc(100% - 100px)', height:'100%', float:'left'}}>
                { props.children }
            </div>
        </div>
    )
}

export function Appearance( props )
{
    const data = props.data 
    const setData = props.setData 

    const [ dynamicHide, setDynamicHide ] = useState( (data.dynamic_hide) ? data.dynamic_hide : {} )

    const reload = () => {
        setDynamicHide( (data.dynamic_hide) ? data.dynamic_hide : {} )
    }

    useEffect( () => {
        reload()
    },[ data ])

    useEffect( () => {
        if( dynamicHide == null )
        {
            return
        }

        let d = structuredClone(data) 
        d.dynamic_hide = dynamicHide 

        if( JSON.stringify(d) != JSON.stringify(data) )
        {
            setData(d)
        }
    },[ dynamicHide ])

    if( dynamicHide == null )
    {
        return (
            <></>
        )
    }

    return (
        <div style={{ width:'100%' }}>
            <div className="d-flex justify-content-end" style={{ width:'100%', marginBottom:'5px' }}>
                <b>Appearance</b>
            </div>
            <div>
                <Item name="Hide when">
                    <VariableForm data={dynamicHide} setData={setDynamicHide}/>
                </Item> 
            </div>

        </div>
    )
}

export function Behavior( props )
{
    const data = props.data 
    const setData = props.setData

    const [ autoReset, setAutoReset ] = useState( (data.auto_reset) ? data.auto_reset : "" )

    const reload = () => {
        setAutoReset( (data.auto_reset) ? data.auto_reset : "" )
    }

    useEffect( () => {
        reload();
    },[data])

    useEffect( () => {
        if( autoReset == null )
        {
            return 
        }

        let d = structuredClone(data)
        d.auto_reset = autoReset 

        if( JSON.stringify(d) != JSON.stringify(data) )
        {
            setData(d)
        }

    },[autoReset])

    return (
        <div style={{ width:'100%' }}>
            <div className="d-flex justify-content-end" style={{ width:'100%', marginBottom:'5px' }}>
                <b>Behavior</b>
            </div>
            <div>
                <Item name="Auto reset">
                    <Form.Select size="sm"
                                 value={autoReset}
                                 onChange={ e => setAutoReset(e.target.value) }
                    >
                        <option value="inactive">Inactive</option>
                        <option value="when_shown">When shown</option>
                    </Form.Select>
                </Item>
            </div>

        </div>
    )
}

export default function SettingsModal( props )
{
    const showModal = props.showModal 
    const closeModal = props.closeModal
    const saveCloseModal = props.saveCloseModal 
    const settings = props.settings

    const [ appearance, setAppearance ] = useState(null)
    const [ behavior, setBehavior ] = useState(null)

    const reload = () => {
        console.log( settings )
        setAppearance( (settings.appearance) ? settings.appearance : {} )
        setBehavior( (settings.behavior) ? settings.behavior : {} )
    }

    useEffect( () => {
        if( showModal )
        {
            reload()
        }
    },[showModal])

    const save = () => {
        let s = structuredClone(settings)
        s.appearance = appearance 
        s.behavior = behavior
        saveCloseModal(s)
    }

    return (
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header>
                Widget Settings
            </Modal.Header>
            <Modal.Body style={{ fontSize:11 }}>
                { (appearance != null & showModal ) &&
                <Appearance data={appearance} setData={setAppearance} />
                }

                { (behavior != null && showModal) &&
                <Behavior data={behavior} setData={setBehavior} />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="contained" 
                        size="sm" 
                        style={{ marginRight:'5px', textTransform:'none' }} 
                        onClick={closeModal}>
                    Close
                </Button>
                <Button variant="contained" 
                        size="sm" 
                        style={{ textTransform:'none' }}
                        onClick={save}
                >
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

